import React, { useState, useEffect } from 'react';
import { Form, Col } from "react-bootstrap";
import moment from 'moment';
//imports core
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import ModalUpdateOccurrence from 'components/ModalUpdateOccurrence/ModalUpdateOccurrence';
import ModalViewOccurrenceType from 'components/ModalViewOccurrenceType/ModalViewOccurrenceType';
import Table from "components/Table/Table.js";
import ModalAddOccurrence from "components/ModalAddOccurrence/ModalAddOccurrence";
import CardFooter from 'components/Card/CardFooter';
import useAuth from "hooks/useAuth";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import { formatDate } from "services/formatDate.js";
import api from 'assets/services/api';
//imports material
import Icon from "@material-ui/core/Icon";
import ReceiptIcon from '@material-ui/icons/Receipt';
import Close from "@material-ui/icons/Close";
import Delete from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Collapse, Typography, Box } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GetAppIcon from "@material-ui/icons/GetApp";
import ModalAddPaymentSell from 'components/ModalAddPaymentSell/ModalAddPaymentSell';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ModalDeliverySell from 'components/ModalDevliverySell/ModalDeliverySell';
import Edit from "@material-ui/icons/Edit";
import { Check } from '@material-ui/icons';


const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    acctAll: {
        float: "right",
        marginTop: "-35px"
    },
    floatRight: {
        float: "right",
        marginRight: "56px",
        marginTop: "12px"
    },
    tp: {
        marginTop: "10px",
    },
    upload: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#000000",
        backgroundColor: "transparent",
        marginTop: "10px",
        border: "none",
    },
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

function Occurrence() {
    const { storageId, storageUserType } = useAuth();

    const classes = useStyles();
    const classes2 = useStyles2();

    const [modal, setModal] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [modalShowType, setModalShowType] = useState(false);

    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [index, setIndex] = useState();
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [search, setSearch] = useState("");
    const [occurrences, setOccurrences] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadOccurrences();
    }, []);


    const loadModal = async () => {
        setModal(true);
    };
    function callModalUpdate(index) {
        if (!modalShowUpdate) {
            loadModal();
        };
        setIndex(index);
        setModalShowUpdate(true);
    };
    function callModalAdd(index) {
        if (!modalShow) {
            loadModal();
        };
        setIndex(index);
        setModalShow(true);
    };
    function callModalViewOccurrenceType(index) {
        if (!modalShow) {
            loadModal();
        };
        setIndex(index);
        setModalShowType(true);
    };


    const loadOccurrences = async () => {
        const response = await api.get(`/occurrence/${storageId}?page=${page}&search=${search}`);
        console.log(response.data);
        if (response.data.occurrences.length > 0) {
            setOccurrences(response.data.occurrences);
            setTotalPages(response.data.pagination.totalPages);
        }
    }

    function getNf(i) {
        let teste = [];
        if (!occurrences[i] || !occurrences[i].products) return teste;
        for (let j = 0; j < occurrences[i].products.length; j++) {
            teste[j] = [];
            teste[j].push(moment(occurrences[i].products[j].date).format('DD/MM/YYYY'));
            teste[j].push(occurrences[i].products[j].name);
            teste[j].push(occurrences[i].products[j].amount);
            teste[j].push(
                <div className={classes2.tableActions}>

                    <CardIcon>
                        <Icon title={occurrences[i].products[j].returned ? "Validado" : "Não validado"}>{occurrences[i].products[j].returned ? "done" : "clear"}</Icon>
                    </CardIcon>
                </div>
            );
            /*    teste[j].push(
                    <div className={classes2.tableActions}>
                        <Tooltip id="tooltip-top" title="Editar" placement="top" classes={{ tooltip: classes2.tooltip }}>
                            <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => { }}>
                                <Edit className={classes2.tableActionButtonIcon + " " + classes2.edit} />
                            </IconButton>
                        </Tooltip>
                    </div>
                );  */
        }
        return teste;
    };
    function getColor(resolve) {
        if (resolve) {
            return "success"
        } else {
            return "danger"
        };
    };

    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="success">
                                <Icon>content_copy</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <h6 className={classes.colorCard}>Adicionar ocorrência</h6>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Button color="success" className={classes.margintp + classes.maxwidht} onClick={() => callModalAdd()}>
                            Adicionar ocorrência
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="info">
                                <Icon>content_copy</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <h6 className={classes.colorCard}>Adicionar tipo de ocorrencia</h6>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Button color="info" className={classes.margintp + classes.maxwidht} onClick={() => { callModalViewOccurrenceType() }}>
                            Adicionar tipo
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            {
                occurrences.map((index, i) => (
                    <GridItem xs={12} sm={12} md={12} key={i}>
                        <Card>
                            <CardHeader className={classes.zindex} color={getColor(index.resolve)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <Typography variant='h6' style={{ color: 'white' }}>
                                        {index.tittle}
                                    </Typography>
                                    <Typography variant="body1" style={{ color: 'white', fontSize: '1.5em' }}>
                                        {index.description}
                                    </Typography>
                                    <Typography variant="body1" style={{ color: 'white', display: 'inline', fontSize: '1.5em' }}>
                                        {index.username} - {moment(index.created_at).format('DD/MM/YYYY HH:mm')}  {index.resolve ? moment(index.updated_at).format('DD/MM/YYYY HH:mm') : (<></>)}
                                    </Typography>
                                </div>
                                {index.resolve ? (<></>) :
                                    (<Tooltip id="tooltip-top" title="Resolver" placement="top" classes={{ tooltip: classes2.tooltip }} style={{ marginRight: '1em', backgroundColor: 'orange' }}>
                                        <IconButton aria-label="Edit" className={classes2.tableActionButtonIconResolve} onClick={() => { callModalUpdate(index) }}>
                                            <Check className={classes2.edit2} style={{ fontSize: 30 }} />
                                        </IconButton>
                                    </Tooltip>)
                                }
                            </CardHeader>
                            <CardBody>
                                <Table
                                    tableHeaderColor="danger"
                                    index={index}
                                    tableHead={["Data", "Produto", "Quantidade", "Retornou"]}
                                    tableData={getNf(i)}
                                />
                            </CardBody>
                        </Card>
                    </GridItem>
                ))
            }
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}
                onClick={() => { }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {modalShow && modal && (
                <ModalAddOccurrence key={"new_occurrence"} show={modalShow} loadOccurrences={() => loadOccurrences()} onHide={() => setModalShow(false)} />
            )}
            {modalShowUpdate && modal && (
                <ModalUpdateOccurrence key={"upd_occurrence"} occurrence={index} show={modalShowUpdate} loadOccurrences={() => loadOccurrences()} onHide={() => setModalShowUpdate(false)} />
            )}
            {modalShowType && modal && (
                <ModalViewOccurrenceType key={"upd_occurrence"} occurrence={index} show={modalShowType} onHide={() => setModalShowType(false)} />
            )}
        </GridContainer>
    );
}

export default Occurrence;